export const enum ResponseErrors {
    none = "",
    required = "This field is required",
    maxChars = "Maximum characters reached",
    validEmail = "Please enter a valid email address",
    validBusinessEmail = "Please enter a business email address",
    validURL = "Please enter a valid website address",
    requireChoice = "Please select a choice",
    tooFew = "Please select at least",
    tooMany = "Please select at most",
    requireBetween = "Please select between",
    validNumber = "Please enter a valid number",
    minNum = "Please enter a number greater than",
    maxNum = "Please enter a number less than",
    requiredAll = "Please fill out all contact fields",
    firstNameRequired = "First name is required",
    lastNameRequired = "Last name is required",
    phoneRequired = "Phone number is required",
    emailRequired = "Email is required",
    companyRequired = "Company is required",
}